// extracted by mini-css-extract-plugin
export default {"video_container":"Video_video_container__Eqy74","video_desc":"Video_video_desc__r9PF3"};